import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, useContext, useImperativeHandle, useRef } from 'react';
import { FILE } from '../../../constants';
import { Context } from '../Context';
import { Input } from './Input';
const DEFAULT_MAX_FILE_SIZE_IN_BYTES = 8000000;
const WAIT_TIME = 250;
class InvalidFileSizeError extends Error {
}
const File = forwardRef(({ accept = '.png,.jpg,.jpeg,.pdf', maxFileSizeInBytes = DEFAULT_MAX_FILE_SIZE_IN_BYTES, onChange = () => Promise.resolve(), onError = () => {
    // does nothing
}, ...rest }, ref) => {
    const { setIsLoading } = useContext(Context);
    const inputFileRef = useRef(null);
    useImperativeHandle(ref, () => inputFileRef.current);
    async function handleOnChange(evt) {
        var _a, _b;
        setIsLoading(true);
        const files = evt.target.files;
        const invalidFileSize = files
            ? Array.from(files).some(file => file.size > maxFileSizeInBytes)
            : false;
        if (invalidFileSize) {
            (_a = inputFileRef === null || inputFileRef === void 0 ? void 0 : inputFileRef.current) === null || _a === void 0 ? void 0 : _a.setCustomValidity('Invalid file size');
            setIsLoading(false);
            return onError(new InvalidFileSizeError('Invalid file size'));
        }
        (_b = inputFileRef === null || inputFileRef === void 0 ? void 0 : inputFileRef.current) === null || _b === void 0 ? void 0 : _b.setCustomValidity('');
        await Promise.allSettled([
            onChange(evt),
            new Promise(resolve => setTimeout(resolve, WAIT_TIME))
        ]);
        setIsLoading(false);
        evt.target.value = '';
    }
    return (_jsx(Input, { accept: accept, onChange: handleOnChange, ref: inputFileRef, ...rest, type: "file" }));
});
File.displayName = FILE;
export { File };
//# sourceMappingURL=File.js.map